import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5dbf78e8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dbf78e8')) {
      api.createRecord('5dbf78e8', component.options)
    } else {
      api.reload('5dbf78e8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5dbf78e8", function () {
      api.rerender('5dbf78e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/wenzhen/index.vue"
export default component.exports